"use strict";

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDispatcher = void 0;

var createDispatcher = () => {
  var callbacks = {};

  var dispatch = (eventName, data) => {
    // Create a cloned version of the original events array
    // This is required to prevent race conditions when adding/removing event callbacks
    [...(callbacks[eventName] || [])].forEach(callback => {
      callback(data);
    });
  };

  var registerEventListener = (eventName, callback) => {
    callbacks[eventName] = [...(callbacks[eventName] || []), callback];
  };

  var unregisterEventListener = (eventName, callback) => {
    if (!callbacks[eventName]) return;
    callbacks[eventName] = callbacks[eventName].filter(cb => cb !== callback);
  };

  var unregisterAllFeatureEventListeners = frameId => {
    callbacks = Object.keys(callbacks).reduce((updatedCallbacks, eventName) => {
      if (!eventName.startsWith(frameId)) {
        updatedCallbacks[eventName] = callbacks[eventName];
      }

      return updatedCallbacks;
    }, {});
  };

  return {
    dispatch,
    registerEventListener,
    unregisterEventListener,
    unregisterAllFeatureEventListeners
  };
};

exports.createDispatcher = createDispatcher;